/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".status-container[_ngcontent-%COMP%] {\n    width:100%;\n    max-width:360px;\n    margin-left:auto;\n    margin-right:auto;\n    line-height:17px !important;\n    border-radius:5px;\n}\n\n.text-small[_ngcontent-%COMP%] {\n    font-size:13px;\n}\n\n.bg-light[_ngcontent-%COMP%]:nth-child(even) {\n    background:#FFF !important;\n}\n\n.navbar[_ngcontent-%COMP%] {\n  width:100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n}\n\n.hidden[_ngcontent-%COMP%] {\n  display: none;\n}"];
export { styles as styles };
